<!-- 首页 -->
<template>
	<div class="wrap">

		<div class="container-wrap">
			<div class="content-width">

				<ul class="header-nav-list">
					<li v-for="(item, index) in menuListTop"
						:key="index"
						:class="menuColorsClass[index % 6]"
						@click="toSeasonalHealth(item.id, item.title)"
					>
						<a href="javascript:void(0)">
							<p class="header-nav-row">
								<span>{{item.title}}</span>
								<!-- <span>{{item.desc || ''}}</span> -->
								<!-- <span>{{item.desc || '没有返回副标题'}}</span> -->
							</p>
							<img :src="item.logo" class="header-nav-img">
						</a>
					</li>
				</ul>
				<!-- 带搜索的头部 -->
				<header-search></header-search>

				<div class="center-module">
					<div class="center-leftsidebar">
						<ul class="leftsidebar-navList">
							<li v-for="(item, index) in goodsCate" :key="index" @click="$router.push(`/classification?index=${index}`)">
								<a href="javascript:void(0)">
									<img :src="item.logo">
									{{item.title}}
								</a>
							</li>
						</ul>
						<ul class="leftsidebar-navList2">
							
							<li v-for="(item, index) in menuList" :key="index" @click="toRaiseFiveInternalOrgans(item.id, item.title)">
								<a href="javascript:void(0)">
									<img :src="item.logo">
									{{item.title}}
								</a>
							</li>

						</ul>
					</div>
					<div class="center-middlesidebar">
						<swiper class="swiper" :options="swiperOption">
							<swiper-slide v-for="(item, index) in banner1" :key="index">
								<img :src="item.cover" class="bannerImg">
							</swiper-slide>
							<div class="swiper-pagination" slot="pagination"></div>
						</swiper>
						<ul class="center-menuList">
							<li @click="goodFor(item.id, item.title)" v-for="(item, index) in regionList" :key="index">
								<a href="javascript:void(0)">
									<p class="center-menuRow">
										<span class="center-menuTitle">{{item.title}}</span>
										<span class="center-menuMsg ">{{item.desc}}</span>
									</p>
								</a>
							</li>
						</ul>
					</div>
					<div class="center-rightsidebar">
						<div class="personal-information-box">
							<img v-if="isLogin" :src="userInfo.headimg" class="personal-avatar">
							<img v-else src="../../assets/avatar.png" class="personal-avatar">
							<div class="personal-information-column">
								<p class="personal-name">{{userInfo.name}}</p>
								<div class="personal-tag" @click="myMember" v-if="isLogin">
									<img src="../../assets/icon-3.png" class="tag-icon">
									{{userInfo.level_name}}
								</div>
							</div>
							<button type="button" class="set-up-btn" @click="setUp()">
								<img src="../../assets/my-head2.png" class="set-up-icon">
							</button>
						</div>
						<div class="card-wrap">
							<div class="card">
								<div class="card-top">
									<span @click="myFans">我的粉丝 <b>{{userInfo.fans}}</b></span>
									<span @click="myCommission">我的佣金 <b>{{userInfo.wallet.money}}</b></span>
								</div>
								<ul class="card-bottom">
									<li @click="myCollection">
										<span>{{userInfo.collect}}</span>
										<span>收藏</span>
									</li>
									<li @click="browsingHistory">
										<span>{{userInfo.track_num}}</span>
										<span>足迹</span>
									</li>
									<li @click="myPoints">
										<span>{{userInfo.wallet.integral}}</span>
										<span>积分</span>
									</li>
									<li @click="cardVoucher">
										<span>{{userInfo.coupon_num}}</span>
										<span>卡券</span>
									</li>
								</ul>
							</div>
						</div>
						<div class="my-order-wrap">
							<div class="title-row">
								<span class="title-bold">我的订单</span>
								<a href="javascript:void(0)" class="all-row" @click="myOrder(-1)">
									查看全部订单
									<img src="../../assets/back-icon.png" class="back-icon">
								</a>
							</div>
							<ul class="my-order-list">
								<li @click="myOrder(0)">
									<a href="javascript:void(0)">
										<img src="../../assets/menu-1.png">
										待付款
										<span class="circle-num" v-if="userInfo.order_stat">{{userInfo.order_stat.no_pay}}</span>
									</a>
								</li>
								<li @click="myOrder(1)">
									<a href="javascript:void(0)">
										<img src="../../assets/menu-2.png">
										待发货
										<span class="circle-num" v-if="userInfo.order_stat">{{userInfo.order_stat.no_deliver}}</span>
									</a>
								</li>
								<li @click="myOrder(2)">
									<a href="javascript:void(0)">
										<img src="../../assets/menu-3.png">
										待收货
										<span class="circle-num" v-if="userInfo.order_stat">{{userInfo.order_stat.no_receive}}</span>
									</a>
								</li>
								<li @click="myOrder(3)">
									<a href="javascript:void(0)">
										<img src="../../assets/menu-4.png">
										待评价
										<span class="circle-num" v-if="userInfo.order_stat">{{userInfo.order_stat.no_comment}}</span>
									</a>
								</li>
								<li @click="myOrder(8)">
									<a href="javascript:void(0)">
										<img src="../../assets/menu-5.png">
										售后
									</a>
								</li>
							</ul>
						</div>
						<div class="information-wrap">
							<div class="title-row">
								<span class="title-bold">资讯信息</span>
							</div>
							<ul class="information-list">
								<li v-if="informationList.new_article" @click="consultationResultsDetails(informationList.new_article.id)">
									<a href="javascript:void(0)">
										<span class="information-tag">最新</span>
										<p class="information-title">{{informationList.new_article.title}}</p>
									</a>
								</li>
								<li v-if="informationList.top_article" @click="consultationResultsDetails(informationList.top_article.id)">
									<a href="javascript:void(0)">
										<span class="information-tag">热门</span>
										<p class="information-title">{{informationList.top_article.title}}</p>
									</a>
								</li>
								<li v-if="informationList.hot_article" @click="consultationResultsDetails(informationList.hot_article.id)">
									<a href="javascript:void(0)">
										<span class="information-tag">推荐</span>
										<p class="information-title">{{informationList.hot_article.title}}</p>
									</a>
								</li>
								<!-- <li>
									<a href="javascript:void(0)">
										<span class="information-tag">公告</span>
										<p class="information-title">关于推进账号乱象专项正直的通知</p>
									</a>
								</li>
								<li>
									<a href="javascript:void(0)">
										<span class="information-tag">热点</span>
										<p class="information-title">《平台违禁信息管理制度》规则变更</p>
									</a>
								</li>
								<li>
									<a href="javascript:void(0)">
										<span class="information-tag">上新</span>
										<p class="information-title">最先上市：西藏冬虫夏草 云南白药 青海</p>
									</a>
								</li>
								<li>
									<a href="javascript:void(0)">
										<span class="information-tag">热点</span>
										<p class="information-title">双11活动价格促销通知活动价格促销通知</p>
									</a>
								</li> -->
							</ul>
						</div>
					</div>
				</div>

				<!-- <div class="seconds-kill-module" @click="$router.push('/index/seconds-kill')">
					<div class="limited-time-seconds-kill">
						<span class="limited-time-label">限时秒杀</span>
						<img src="../../assets/icon-4.png" class="limited-time-icon">
						<span class="limited-time-msg"><b>14:00</b> 开抢中 距结束</span>
						<div class="countdown">
							<span>00</span>
							<span>:</span>
							<span>23</span>
							<span>:</span>
							<span>55</span>
						</div>
					</div>
					<div class="seconds-kill-sidebar">
						<ul class="seconds-kill-list">
							<li>
								<img src="../../assets/img-2.png" class="seconds-kill-img">
								<p class="seconds-kill-name">云南香格里拉松茸</p>
								<span class="seconds-kill-price">￥<span>34.00</span></span>
							</li>
							<li>
								<img src="../../assets/img-2.png" class="seconds-kill-img">
								<p class="seconds-kill-name">云南香格里拉松茸</p>
								<span class="seconds-kill-price">￥<span>34.00</span></span>
							</li>
							<li>
								<img src="../../assets/img-2.png" class="seconds-kill-img">
								<p class="seconds-kill-name">云南香格里拉松茸</p>
								<span class="seconds-kill-price">￥<span>34.00</span></span>
							</li>
							<li>
								<img src="../../assets/img-2.png" class="seconds-kill-img">
								<p class="seconds-kill-name">云南香格里拉松茸</p>
								<span class="seconds-kill-price">￥<span>34.00</span></span>
							</li>
						</ul>
					</div>
				</div> -->

				<div style="width: 100%;display: flex;flex-wrap: wrap;">
					<div class="module-between-gap" style="margin-bottom: 10px !important;">
						<div class="module-between-gap-item" @click="subHealthPool">
							<p class="module-between-gap-item-title">
								亚健康汇
								<img src="../../assets/back-icon2.png">
							</p>
							<div class="module-between-gap-list">
								<div class="module-between-gap-column" v-if="regionRecommend[0].length > 0">
									<div class="module-between-gap-bigItem">
										<img :src="regionRecommend[0][0].cover" class="module-between-gap-img">
										<p class="module-between-gap-name">{{regionRecommend[0][0].name}}</p>
										<span class="module-between-gap-price">￥<span>{{regionRecommend[0][0].low_price}}</span></span>
									</div>
								</div>
								<div class="module-between-gap-column" v-if="regionRecommend[0].length > 1">
									<div class="module-between-gap-smallItem" v-for="(item, index) in regionRecommend[0]" :key="index">
										<img :src="item.cover" class="module-between-gap-img">
										<p class="module-between-gap-name">{{item.name}}</p>
										<span class="module-between-gap-price">￥<span>{{item.low_price}}</span></span>
									</div>
								</div>
								<div class="normal-box-middle" v-if="regionRecommend[0].length <= 1">
									<img src="../../assets/normal-4.png">
									暂无数据
								</div>
							</div>
						</div>

						<div class="module-between-gap-item" @click="giftHeartChoose">
							<p class="module-between-gap-item-title">
								礼品心选
								<img src="../../assets/back-icon2.png">
							</p>
							<div class="module-between-gap-list">
								<div class="module-between-gap-column" v-if="regionRecommend[1].length > 0">
									<div class="module-between-gap-bigItem">
										<img :src="regionRecommend[1][0].cover" class="module-between-gap-img">
										<p class="module-between-gap-name">{{regionRecommend[1][0].name}}</p>
										<span class="module-between-gap-price">￥<span>{{regionRecommend[1][0].low_price}}</span></span>
									</div>
								</div>
								<div class="module-between-gap-column" v-if="regionRecommend[1].length > 1">
									<div class="module-between-gap-smallItem" v-for="(item, index) in regionRecommend[1]" :key="index">
										<img :src="item.cover" class="module-between-gap-img">
										<p class="module-between-gap-name">{{item.name}}</p>
										<span class="module-between-gap-price">￥<span>{{item.low_price}}</span></span>
									</div>
								</div>
								<div class="normal-box-middle" v-if="regionRecommend[1].length <= 1">
									<img src="../../assets/normal-4.png">
									暂无数据
								</div>
							</div>
						</div>
					</div>
					<div class="module-between-gap">
						<div class="module-between-gap-item" @click="secondsKill">
							<p class="module-between-gap-item-title">
								限时秒杀
								<img src="../../assets/back-icon2.png">
							</p>
							<div class="module-between-gap-list">
								<div class="module-between-gap-column" v-if="regionRecommend[2].length > 0">
									<div class="module-between-gap-bigItem">
										<img :src="regionRecommend[2][0].cover" class="module-between-gap-img">
										<p class="module-between-gap-name">{{regionRecommend[2][0].name}}</p>
										<span class="module-between-gap-price">￥<span>{{regionRecommend[2][0].low_price}}</span></span>
									</div>
								</div>
								<div class="module-between-gap-column" v-if="regionRecommend[2].length > 1">
									<div class="module-between-gap-smallItem" v-for="(item, index) in regionRecommend[2]" :key="index">
										<img :src="item.cover" class="module-between-gap-img">
										<p class="module-between-gap-name">{{item.name}}</p>
										<span class="module-between-gap-price">￥<span>{{item.low_price}}</span></span>
									</div>
								</div>
								<div class="normal-box-middle" v-if="regionRecommend[2].length <= 1">
									<img src="../../assets/normal-4.png">
									暂无数据
								</div>
							</div>
						</div>

						<div class="module-between-gap-item" @click="limitedSourcePreSale">
							<p class="module-between-gap-item-title">
								限源预售
								<img src="../../assets/back-icon2.png">
							</p>
							<div class="module-between-gap-list">
								
								<div class="module-between-gap-column" v-if="regionRecommend[3].length > 0">
									<div class="module-between-gap-bigItem">
										<img :src="regionRecommend[3][0].cover" class="module-between-gap-img">
										<p class="module-between-gap-name">{{regionRecommend[3][0].name}}</p>
										<span class="module-between-gap-price">￥<span>{{regionRecommend[3][0].low_price}}</span></span>
									</div>
								</div>
								<div class="module-between-gap-column" v-if="regionRecommend[3].length > 1">
									<div class="module-between-gap-smallItem" v-for="(item, index) in regionRecommend[3]" :key="index">
										<img :src="item.cover" class="module-between-gap-img">
										<p class="module-between-gap-name">{{item.name}}</p>
										<span class="module-between-gap-price">￥<span>{{item.low_price}}</span></span>
									</div>
								</div>
								<div class="normal-box-middle" v-if="regionRecommend[3].length <= 1">
									<img src="../../assets/normal-4.png">
									暂无数据
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- 7商城广告 -->
				<!-- <img src="../../assets/banner-2.png" class=""> -->

				<swiper class="swiper" :options="swiperOption">
					<swiper-slide v-for="(item, index) in banner7" :key="index">
						<img :src="item.cover" class="banner-logo">
					</swiper-slide>
					<div class="swiper-pagination" slot="pagination"></div>
				</swiper>
				<!-- 手机端的去掉了，所以PC端的也先注释掉 -->
				<!-- <div class="module-between-border">
					<div class="module-between-item" @click="$router.push('/index/seasonal-nutrition-recommended')">
						<div class="module-between-item-title">
							<p class="module-between-item-title-row">
								时令营养
								<span>滋补免疫推荐</span>
							</p>
							<button type="button" class="all-btn">全部</button>
						</div>
						<swiper class="swiper swiper-3" :options="swiperOption3">
							<swiper-slide>
								<ul class="module-between-list">
									<li>
										<a href="javascript:void(0)">
											<div class="module-between-imgBox">
												<img src="../../assets/img-3.png">
												<p>杞里香枸杞子宁夏特级500g</p>
											</div>
											<div class="module-between-bottom">
												<span>￥394.00</span>
												<span>￥34.00</span>
											</div>
										</a>
									</li>
									<li>
										<a href="javascript:void(0)">
											<div class="module-between-imgBox">
												<img src="../../assets/img-3.png">
												<p>杞里香枸杞子宁夏特级500g</p>
											</div>
											<div class="module-between-bottom">
												<span>￥394.00</span>
												<span>￥34.00</span>
											</div>
										</a>
									</li>
									<li>
										<a href="javascript:void(0)">
											<div class="module-between-imgBox">
												<img src="../../assets/img-3.png">
												<p>杞里香枸杞子宁夏特级500g</p>
											</div>
											<div class="module-between-bottom">
												<span>￥394.00</span>
												<span>￥34.00</span>
											</div>
										</a>
									</li>
								</ul>
							</swiper-slide>
							<swiper-slide>
								<ul class="module-between-list">
									<li>
										<a href="javascript:void(0)">
											<div class="module-between-imgBox">
												<img src="../../assets/img-3.png">
												<p>杞里香枸杞子宁夏特级500g</p>
											</div>
											<div class="module-between-bottom">
												<span>￥394.00</span>
												<span>￥34.00</span>
											</div>
										</a>
									</li>
									<li>
										<a href="javascript:void(0)">
											<div class="module-between-imgBox">
												<img src="../../assets/img-3.png">
												<p>杞里香枸杞子宁夏特级500g</p>
											</div>
											<div class="module-between-bottom">
												<span>￥394.00</span>
												<span>￥34.00</span>
											</div>
										</a>
									</li>
									<li>
										<a href="javascript:void(0)">
											<div class="module-between-imgBox">
												<img src="../../assets/img-3.png">
												<p>杞里香枸杞子宁夏特级500g</p>
											</div>
											<div class="module-between-bottom">
												<span>￥394.00</span>
												<span>￥34.00</span>
											</div>
										</a>
									</li>
								</ul>
							</swiper-slide>
							<div class="swiper-pagination swiper-pagination-other" slot="pagination"></div>
						</swiper>
					</div>
					<div class="module-between-item" @click="$router.push('/index/seasonal-health-food')">
						<div class="module-between-item-title">
							<p class="module-between-item-title-row">
								时令健康
								<span>养生食品推荐</span>
							</p>
							<button type="button" class="all-btn">全部</button>
						</div>
						<swiper class="swiper swiper-3" :options="swiperOption3">
							<swiper-slide>
								<ul class="module-between-list">
									<li>
										<a href="javascript:void(0)">
											<div class="module-between-imgBox">
												<img src="../../assets/img-brown.png">
												<p>杞里香枸杞子宁夏特级500g</p>
											</div>
											<div class="module-between-bottom">
												<span>￥394.00</span>
												<span>￥34.00</span>
											</div>
										</a>
									</li>
									<li>
										<a href="javascript:void(0)">
											<div class="module-between-imgBox">
												<img src="../../assets/img-red.png">
												<p>杞里香枸杞子宁夏特级500g</p>
											</div>
											<div class="module-between-bottom">
												<span>￥394.00</span>
												<span>￥34.00</span>
											</div>
										</a>
									</li>
									<li>
										<a href="javascript:void(0)">
											<div class="module-between-imgBox">
												<img src="../../assets/img-blue.png">
												<p>杞里香枸杞子宁夏特级500g</p>
											</div>
											<div class="module-between-bottom">
												<span>￥394.00</span>
												<span>￥34.00</span>
											</div>
										</a>
									</li>
								</ul>
							</swiper-slide>
							<swiper-slide>
								<ul class="module-between-list">
									<li>
										<a href="javascript:void(0)">
											<div class="module-between-imgBox">
												<img src="../../assets/img-brown.png">
												<p>杞里香枸杞子宁夏特级500g</p>
											</div>
											<div class="module-between-bottom">
												<span>￥394.00</span>
												<span>￥34.00</span>
											</div>
										</a>
									</li>
									<li>
										<a href="javascript:void(0)">
											<div class="module-between-imgBox">
												<img src="../../assets/img-red.png">
												<p>杞里香枸杞子宁夏特级500g</p>
											</div>
											<div class="module-between-bottom">
												<span>￥394.00</span>
												<span>￥34.00</span>
											</div>
										</a>
									</li>
									<li>
										<a href="javascript:void(0)">
											<div class="module-between-imgBox">
												<img src="../../assets/img-blue.png">
												<p>杞里香枸杞子宁夏特级500g</p>
											</div>
											<div class="module-between-bottom">
												<span>￥394.00</span>
												<span>￥34.00</span>
											</div>
										</a>
									</li>
								</ul>
							</swiper-slide>
							<div class="swiper-pagination swiper-pagination-other" slot="pagination"></div>
						</swiper>
					</div>
				</div> -->

				<div class="bottom-module">
					<ul class="bottom-tab-list">
						<li v-for="(item, index) in goodsColumn" :class="{active: isActive == index}" @click="checked(index)" :key="index">
							<a href="javascript:void(0)">
								<span class="child-column-name">{{item.title}}</span>
								<span class="child-column-msg">{{item.desc}}
									<img src="../../assets/icon-5.png" class="border-img">
								</span>
							</a>
						</li>
					</ul>
					<ul class="product-list">
						<li v-for="(item,index) in list" :key="index" @click="productDetails(item.id)">
							<div class="product-item-column2">
								<img :src="item.cover" class="product-item-column2-img">
								<div class="product-item-column2-bottom">
									<div class="product-item-column-name2">{{item.name}}</div>
									<div class="product-item-column2-row-between">
										<div class="product-item-column2-price">
											￥{{item.low_price}}
											<span>￥{{item.low_original}}</span>
										</div>
										<!-- <button type="button" class="product-item-column2-btn">
											<img src="../../assets/add-icon.png">
										</button> -->
									</div>
								</div>
							</div>
						</li>
						<!-- 无数据显示 -->
						<div class="normal-box" v-if="list.length == 0">
							<img src="../../assets/normal-4.png">
							暂无数据
						</div>
					</ul>
				</div>

			</div>
		</div>

		<!-- 	<div class="loading-box">
			<img src="../../assets/icon-6.png">
			滑动加载…
		</div> -->

	</div>
</template>

<script>
	import Header from '../../components/header.vue';
	// 轮播新增 start
	import {
		Swiper,
		SwiperSlide
	} from 'vue-awesome-swiper';
	import 'swiper/css/swiper.css'
	import {
		expediteGetBanner,
		userCenterGetUserInfo,
		expediteGetGoodsList,
		mallIndexGetGoodsColumn,
		mallIndexGetIndexMenu,
		mallIndexGetIndexRegion,
		mallIndexGetRegionRecommend,
    	expediteGetGoodsCate,
		informationGetCateTree,
    	mallIndexGetIndexInformation,
	} from '../../service/service';
	import { listenerScrollToBottom } from '../../utils/util';
	import HeaderSearch from '../../components/header-search.vue';
	// 轮播新增 end

	export default {
		components: {
			Header,
			// 轮播新增 start
			Swiper,
			SwiperSlide,
			HeaderSearch
		},
		data() {
			return {
				// 轮播
				swiperOption: {
					loop: true,
					// 自动轮播
					autoplay: {
						delay: 2500,
						disableOnInteraction: false,
					},
					pagination: {
						el: '.swiper-pagination',
						// type: 'fraction', // 数子，注释掉是圆点
					},
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					}
				},

				// 轮播2
				swiperOption2: {
					loop: true,
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					}
				},

				// 轮播3
				swiperOption3: {
					loop: true,
					pagination: {
						el: '.swiper-pagination',
						// type: 'fraction', // 数子，注释掉是圆点
					},
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					}
				},

				//选项卡
				navId: 0,
				navList: [{
					title: "精选推荐",
					msg: '为您推荐'
				}, {
					title: "健康养生",
					msg: '为您推荐'
				}, {
					title: "营养滋补",
					msg: '为您推荐'
				}, {
					title: "美容养颜",
					msg: '为您推荐'
				}, {
					title: "礼品心选",
					msg: '为您推荐'
				}],
				// 最顶部菜单背景色
				menuColorsClass: [
					'red',
					'blue',
					'pink',
					'green',
					'yellow',
					'purple',
				],

				// 最顶部菜单
				menuListTop: [],
				// 轮播1
				banner1: [],
				// 轮播2
				banner7: [],
				// 轮播1左上方 菜单
				goodsCate: [],
				// 轮播1左下方 菜单
				menuList: [],
				// 轮播1下方 菜单
				regionList: [],
				// 用户信息
				userInfo: {
					wallet: {},
				},
				isLogin: false,
				// 获取首页资讯
				informationList: {},
				
				// 第一个亚健康，第二个礼品心选，第三个秒杀（促销）第四个预售
				regionRecommend: [
					[], // 亚健康
					[], // 礼品心选
					[], // 秒杀（促销）
					[], // 预售
				],
				// 最下方菜单
				goodsColumn: [],
				//选项卡
				isActive: 0,

				// 商品列表
				list: [],
				page: 1,
				page_num: 20,
			}
		},
		mounted() {
			this.getBanner1();
			this.getBanner7();
			this.getGoodsCate();
			this.getIndexMenu();
			this.getIndexRegion();
			this.getUserInfo();
			this.getIndexInformation();
			this.getGoodsColumn();
			this.getRegionRecommend();
			this.getCateTree();
			// 监听滚动到底部
			listenerScrollToBottom(() => this.getGoodsList());
		},
		methods: {
			// 获取分类
			getCateTree() {
				informationGetCateTree().then(({ code, msg, data }) => {
					if (code == 1) {
						this.menuListTop = data.list;
					} else {
						this.$message.error(msg);
					}
				});
			},
			// 获取用户信息
			getUserInfo() {
				userCenterGetUserInfo().then(({code, data, msg}) => {
					if (code == 1) {
						localStorage.setItem('USER_INFO', JSON.stringify(data.detail));
						this.userInfo = data.detail;
						this.isLogin = true;
					} else {
						this.$message.error(msg);
					}
				});
			},
			
			// 获取banner1左上角菜单
			getGoodsCate() {
				expediteGetGoodsCate({}).then(({ code, msg, data }) => {
					if (code == 1) {
						this.goodsCate = data.list;
					} else {
						this.$message.error(msg);
					}
				});
			},

			// 获取有奖发布
			getBanner1() {
				// 展示位置1商城首页2营养百科3视频专栏4商城商品5商城活动6商城分类7商城广告8预售
				expediteGetBanner({place: 1}).then(({ code, msg, data}) => {
					if (code == 1) {
						this.banner1 = data.list;
					} else {
						this.$message.error(msg);
					}
				});
			},
			
			// 获取有奖发布
			getBanner7() {
				// 展示位置1商城首页2营养百科3视频专栏4商城商品5商城活动6商城分类7商城广告8预售
				expediteGetBanner({place: 7}).then(({ code, msg, data}) => {
					if (code == 1) {
						this.banner7 = data.list;
					} else {
						this.$message.error(msg);
					}
				});
			},
			// 获取首页资讯
			getIndexInformation() {
				mallIndexGetIndexInformation().then(({ code, msg, data }) => {
					if (code == 1) {
						this.informationList = data.list;
					} else {
						this.$message.error(msg);
					}
				});
			},

			// 获取首页菜单(一级)
			getIndexMenu() {
				mallIndexGetIndexMenu().then(({ code, msg, data }) => {
					if (code == 1) {
						this.menuList = data;
					} else {
						this.$message.error(msg);
					}
				});
			},
			// 获取首页推荐商品区(一级)
			getIndexRegion() {
				mallIndexGetIndexRegion().then(({ code, msg, data }) => {
					if (code == 1) {
						this.regionList = data;
					} else {
						this.$message.error(msg);
					}
				});
			},

			getGoodsColumn() {
				mallIndexGetGoodsColumn().then(({ code, msg, data }) => {
					if (code == 1) {
						this.goodsColumn = data.list;
						this.getGoodsList();
					} else {
						this.$message.error(msg);
					}
				});
			},
			getRegionRecommend() {
				mallIndexGetRegionRecommend({ num: 5 }).then(({ code, msg, data }) => {
					if (code == 1) {
						this.regionRecommend = data.list;
					} else {
						this.$message.error(msg);
					}
				});
			},
			
			// 获取列表
			getGoodsList() {
				const {
					page,
					page_num
				} = this;
				const params = {
					page,
					page_num,
					column_id: this.goodsColumn[this.isActive].id,
				};
				expediteGetGoodsList(params).then(({code, msg, data}) => {
					if (code === 1) {
						const list = data.list;
						this.list = page > 1 ? [...this.list, ...list] : list;
						if (list.length === 0) {
							this.$message.info('没有更多数据了');
						} else {
							this.page = this.page + 1;
						}
					} else {
						this.$message.error(msg);
					}
				});
			},

			checked(index) {
				this.isActive = index;
				this.page = 1;
				this.getGoodsList();
			},
			active(index) {
				this.active = index;
			},
			// 分类内页
			toSeasonalHealth(id, title) {
				this.$router.push(`/health-encyclopedia/seasonal-health?id=${id}&title=${title}`);
			},
			// banner左下角菜单内页
			toRaiseFiveInternalOrgans(id, title) {
				this.$router.push(`/index/raise-five-internal-organs?id=${id}&title=${title}`);
			},
			//跳转搜索
			search(searchStr) {
				this.$router.push('/index/search?searchStr=' + searchStr);
			},
			//跳转视频专栏
			videoColumn() {
				this.$router.push('/index/video-column')
			},
			//跳转消息
			message() {
				this.$router.push('/my/message')
			},
			//跳转我的粉丝
			myFans() {
				this.$router.push('/my/my-fans')
			},
			//跳转我的佣金
			myCommission() {
				this.$router.push('/my/my-commission')
			},
			//跳转我的收藏
			myCollection() {
				this.$router.push('/my/my-collection')
			},
			//跳转积分
			myPoints() {
				this.$router.push('/my/my-points')
			},
			//跳转卡券
			cardVoucher() {
				this.$router.push('/my/card-voucher')
			},
			//跳转我的订单
			myOrder(status) {
				this.$router.push('/my/my-order?status=' + status)
			},
			//跳转设置
			setUp() {
				this.$router.push('/my/set-up')
			},
			//跳转会员
			myMember() {
				this.$router.push('/my/my-member')
			},
			//咨询信息暂时跳咨询结果页
			consultationResults() {
				this.$router.push('/health-encyclopedia/consultation-results')
			},
			//跳转反馈
			feedback() {
				this.$router.push('/my/feedback')
			},
			//品质良作
			goodFor(id, title) {
				this.$router.push(`/index/good-for?id=${id}&title=${title}`);
			},
			//商品详情
			productDetails(id) {
				this.$router.push('/index/product-details?id=' + id);
			},
			//限源预售
			limitedSourcePreSale() {
				this.$router.push('/index/limited-source-pre-sale')
			},
			//限时秒杀
			secondsKill() {
				this.$router.push('/index/seconds-kill')
			},
			//亚健康汇
			subHealthPool() {
				this.$router.push('/index/sub-health-pool')
			},
			//礼品心选
			giftHeartChoose() {
				this.$router.push('/index/gift-heart-choose')
			},
			// 咨询详情
			consultationResultsDetails(id) {
				this.$router.push('/health-encyclopedia/consultation-results-details?id=' + id);
			},
			// 足迹
			browsingHistory() {
				this.$router.push('/my/browsing-history')
			},
		}
	};
</script>

<style scoped>
	.swiper {
		width: 100%;
		height: 390px;
		margin: 0 auto 10px;
	}

	.swiper-pagination>>>.swiper-pagination-bullet {
		background: #fff !important;
		opacity: 1 !important;
	}

	.swiper-pagination>>>.swiper-pagination-bullet-active {
		opacity: 1;
		background: #F2501A !important;
	}

	.bannerImg {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.swiper-2 {
		width: 100%;
		height: 270px !important;
		margin: 0 !important;
		position: relative;
	}

	.swiper-button-prev:after {
		content: '' !important;
		width: 22px;
		height: 44px;
		background: url(../../assets/turn-left.png) no-repeat;
		background-size: 100% 100%;
	}

	.swiper-button-next:after {
		content: '' !important;
		width: 22px;
		height: 44px;
		background: url(../../assets/turn-right.png) no-repeat;
		background-size: 100% 100%;
	}

	.swiper-slide {
		width: 100% !important;
	}

	.swiper-button-prev {
		left: 0 !important;
	}

	.swiper-button-next {
		right: 0 !important;
	}

	.swiper-button-prev,
	.swiper-button-next {
		z-index: 100000000;
		border: 1px solid;
	}

	.swiper-3 {
		width: 100%;
		height: calc(100% - 72px) !important;
		margin: 0 !important;
	}

	.swiper-pagination-other>>>.swiper-pagination-bullet {
		background: #F2F2F2 !important;
		opacity: 1 !important;
	}

	.swiper-pagination-other>>>.swiper-pagination-bullet-active {
		opacity: 1;
		background: #F2501A !important;
	}
</style>

<style scoped src="@/views/index/index.css">
</style>
